import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(process.env.MUI_X_LICENSE_KEY || '');

export default function MuiXLicense() {
  return null;
}
